export default "__VITE_ASSET__mm4Pno1R__"